const LinkButton = (props) => {
  const { children, func, className } = props;
  return (
    <button className={className} onClick={func}>
      {children}
    </button>
  );
};
export default LinkButton;
